var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-input-code-ui" },
    _vm._l(_vm.fields, function(item, index) {
      return _c("div", { key: index, staticClass: "input-code-ui" }, [
        _vm.labels[index]
          ? _c(
              "label",
              {
                staticClass: "visually-hidden",
                attrs: { for: "input-code-" + index }
              },
              [_vm._v("\n      " + _vm._s(_vm.labels[index]) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          ref: "code" + index,
          refInFor: true,
          staticClass: "input-code-ui__input",
          class: { "input-code-ui__input--focused": _vm.elFocus === index },
          attrs: {
            id: "input-code-" + index,
            "aria-label": "label",
            "aria-required": "true",
            autocomplete: "off",
            "data-index": index,
            inputmode: "numeric",
            type: "tel",
            name: "inputCode" + index,
            maxlength: "1",
            pattern: _vm.pattern
          },
          domProps: { value: item },
          on: {
            input: function($event) {
              return _vm.onChange($event, index)
            },
            keydown: function($event) {
              return _vm.onKeydown($event, index)
            },
            focus: function($event) {
              return _vm.onFocus(index)
            },
            blur: function($event) {
              return _vm.onBlur(index)
            }
          }
        })
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }